module.exports = __webpack_public_path__ + "img/cr1.11a9e88b.png";